module.exports = __webpack_public_path__ + "static/img/banner1.cfc3289.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phoneService/banner1.png
// module id = ISQA
// module chunks = 0